import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function useGoBack(): () => void {
    const navigate = useNavigate();
    return React.useCallback(() => navigate(-1), [navigate]);
}
